import { HttpService } from "@/core";
import { ExportResp } from "@/core/interface";
import { MaterialDetailResp, MaterialImportResp, MaterialReq } from "./material-table.interface";
import NP from "number-precision/src/index";

export class MaterialTableService {
  static useMaterialCreateApi() {
    const api = (changeId: string, data: MaterialReq) =>
      HttpService.axios({
        method: "POST",
        url: `/subcontract/${changeId}/materialList`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }
  static useQuantityListApi() {
    const api = (changeId: string, materialName: string) =>
      HttpService.axios({
        method: "GET",
        url: `/project_work_budget_material/list?status=ysx&projectId=${changeId}&materialName=${materialName}`,
      });
    return HttpService.useRequest<MaterialDetailResp>(api);
  }
  static useMaterialDetailApi() {
    const api = (changeId: string) =>
      HttpService.axios({
        method: "GET",
        //更改材料清单的显示数量
        url: `/subcontract/material?id=${changeId}&current=1&size=1500`,
        // url: `/subcontract/material`,
      });
    return HttpService.useRequest<MaterialDetailResp>(api);
  }

  static useMaterialImportApi() {
    const api = (changeId: string, url: string) =>
      HttpService.axios({
        method: "POST",
        url: `/subcontract/${changeId}/import/material`,
        data: { url },
      });
    return HttpService.useRequest<MaterialImportResp>(api);
  }

  static useMaterialExportApi() {
    const api = (changeId: []) =>
      HttpService.axios({
        method: "GET",
        url: `/subcontract/export/material?ids=${changeId}`,
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }

  static calcMaterials(materials) {
    return (materials || []).map((item) => {
      // 本次变更.合价 = 本次变更.工程量 * 本次变更.单价
      item.changeTotalPrice = NP.times(item.changeCount || 0, item.changePrice || 0);
      // 本次变更后.工程量 = 当前合同.工程量 + 本次变更.工程量
      item.afterChangeCount = NP.plus(item.count || 0, item.changeCount || 0);
      // 本次变更后.合价 = 当前合同.合价 + 本次变更后.合价
      item.afterChangeTotalPrice = NP.plus(item.totalPrice || 0, item.changeTotalPrice || 0);
      // 本次变更后.单价 = 当前合同.单价 + 本次变更.单价
      if (item.afterChangeCount !== 0) {
        item.afterChangePrice = NP.divide(
          item.afterChangeTotalPrice || 0,
          item.afterChangeCount || 0
        );
      }
      return item;
    });
  }
}
